import React from 'react';
import { useEffect, useState } from 'react';
import styled from 'styled-components';

export const Button = styled.a`
    padding: 20px 60px;
    background: white;
    box-shadow: 0px 7px 20px rgba(0, 0, 0, 0.15);
    border-radius: 5px;
    font-weight: 800;
    font-size: 18px;
    line-height: 25px;
    display: block;
    text-align: center;
    color: black;
    cursor: pointer;
    :focus {
        outline: none;
    }
    @media screen and (max-width: 1024px) {
        padding: 15px 40px;
        font-size: 14px;
        line-height: 19px;
    }
`;
export const SendButton = styled(Button)`
    background: #35aaf9;
    color: white;
`;
export const WelcomeButton = styled(Button)`
    background: white;
    color: black;
    @media screen and (max-width: 321px) and (min-width: 0) {
        padding: 10px 15px;
        font-size: 12px;
        line-height: 1;
    }
`;
const MobileButtonStyle = styled(Button)`
    background: #35aaf9;
    color: white;
    z-index: 4;
    position: fixed;
    transition: transform 0.4s;
    bottom: 20px;
    padding: 15px 20px;
    transform: translateX(
        ${props => (props.transform === 'scroll' ? '0' : '-500px')}
    );

    @media screen and (max-width: 800px) {
        padding: 15px 20px;
    }
`;

const FixedButton = styled(Button)`
    z-index: 4;
    position: fixed;
    transition: all 0.4s;
    bottom: 0;
    font-size: 20px;
    line-height: 27px;
    transform: translateY(
        ${props =>
            props.transform === 'hide'
                ? '200px'
                : props.transform === 'scroll'
                ? '-20px'
                : '-60px'}
    );
    @media screen and (max-width: 800px) {
        transform: translateY(
            ${props =>
                props.transform === 'hide'
                    ? '100px'
                    : props.transform === 'scroll'
                    ? '-20px'
                    : '-30px'}
        );
        padding: 17px 22px;
    }
    background: ${props =>
        (props.transform === 'scroll'
            ? '#35aaf9'
            : props.startBackgroundColor) ||
        (props.container === 'light' ? '#35aaf9' : props.startBackgroundColor)};
    color: ${props =>
        (props.transform === 'scroll' ? 'white' : props.startColor) ||
        (props.container === 'light' ? 'white' : props.startColor)};
`;

export const SignupButton = ({
    startBackgroundColor = 'white',
    startColor = 'black',
    text = 'Бесплатный вводный урок',
}) => {
    const [transform, setTransform] = useState('');
    useEffect(() => {
        const listener = () => {
            const heightWindow = window.innerHeight;

            const formSection = document
                .getElementById('form')
                .getBoundingClientRect();

            const button = document
                .getElementById('button')
                .getBoundingClientRect();
            const delta = window.pageYOffset + heightWindow;

            const hideButtonY =
                formSection.top + window.pageYOffset + formSection.height / 2.5;

            const changeButtonY = heightWindow - button.top;

            if (delta > hideButtonY) {
                setTransform('hide');
            } else if (window.pageYOffset > changeButtonY) {
                setTransform('scroll');
            } else {
                setTransform('');
            }
        };

        window.addEventListener('scroll', listener);
        window.addEventListener('resize', listener);

        return () => {
            window.removeEventListener('scroll', listener);
            window.removeEventListener('resize', listener);
        };
    }, []);

    return (
        <FixedButton
            startBackgroundColor={startBackgroundColor}
            startColor={startColor}
            transform={transform}
            id="button"
            href="#form"
        >
            {text}
        </FixedButton>
    );
};

export const MobileSignupButton = ({
    startBackgroundColor = 'white',
    startColor = 'black',
}) => {
    const [transform, setTransform] = useState('');
    useEffect(() => {
        const listener = () => {
            const heightWindow = document.documentElement.clientHeight;

            const formSection = document
                .getElementById('form')
                .getBoundingClientRect();

            const delta = window.pageYOffset + heightWindow;

            const hideButtonY =
                formSection.top + window.pageYOffset + formSection.height / 2.5;

            if (delta > hideButtonY) {
                setTransform('hide');
            } else if (window.pageYOffset > heightWindow) {
                setTransform('scroll');
            } else {
                setTransform('');
            }
        };

        window.addEventListener('scroll', listener);
        window.addEventListener('resize', listener);

        return () => {
            window.removeEventListener('scroll', listener);
            window.removeEventListener('resize', listener);
        };
    }, []);

    return (
        <MobileButtonStyle
            startBackgroundColor={startBackgroundColor}
            startColor={startColor}
            transform={transform}
            id="mobileButton"
            href="#form"
        >
            Бесплатный вводный урок
        </MobileButtonStyle>
    );
};
